module.exports = __webpack_public_path__ + "static/ccgm.6525729d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ccgm.svg
// module id = 477
// module chunks = 35783957827783